import { render, staticRenderFns } from "./InstructorRazuviousComponent.vue?vue&type=template&id=20db4522&"
import script from "./InstructorRazuviousComponent.vue?vue&type=script&lang=js&"
export * from "./InstructorRazuviousComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports